import FlightSeatmap from './flight-seatmap-component';
import SeatmapTokenService from './seatmap-token-service';
import FlightSeatmapService from './flight-seatmap-service';
import SelectedSeatsService from './selected-seats-service';
import SeatmapAvailabilityService from './seatmap-availability-service';

import AmadeusSeatmapModule from './amadeus-seatmap/amadeus-seatmap-module';

import './flight-seatmap.scss';

const MODULE_NAME = 'app.flight.seatmap';
const module = angular.module(MODULE_NAME, [
        AmadeusSeatmapModule,
    ])
    .directive(FlightSeatmap.DIRECTIVE_NAME, FlightSeatmap)
    .service('seatmapTokenService', SeatmapTokenService)
    .service('selectedSeatsService', SelectedSeatsService)
    .service('seatmapAvailabilityService', SeatmapAvailabilityService)
    .service('flightSeatmapService', FlightSeatmapService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-seatmap/flight-seatmap-module.js